export default "__VITE_ASSET__Do3v3dvy__"